export default __webpack_public_path__ + "static/media/Inter-Medium.e7231ba3.ttf";